import { useQuery } from '@tanstack/react-query';

import { axiosGetAutoCancelDecorator } from 'utils/axiosGetAutoCancelDecorator';
import { ICountry } from 'utils/fetchers';

type CountriesQueryRes = {
  data: ICountry[];
};

const decoratedAxiosGet = axiosGetAutoCancelDecorator();

export function useFetchCountries() {
  const countriesQueryRes = useQuery(
    ['countries'],
    () => decoratedAxiosGet('/countries').then(({ data = [] }) => data as CountriesQueryRes),
    {
      staleTime: 86_400_000 * 30, // 30 days
    },
  );

  return countriesQueryRes;
}
